import * as React from "react";
import {connect} from "react-redux";
import * as selectors from "../../selectors";
import {preserveFocus, PreserveFocus, sortFeatures, SortFeatures} from "../../reducers/actions";
import FeaturesState, {
    PreserveFocusData,
    QualityParam,
    SortBy,
    SortOrder,
    SortSetting
} from "../../domain/FeaturesState";
import {DisplayFeature} from "../../domain";
import {AttributeType} from "../../../../../integration/datacatalog/datacatalog-services";
import {Glyphicon, OverlayTrigger, Popover} from "react-bootstrap";
import classNames = require("classnames");

interface SortingHeaderState {
}

interface TagProps {
    sortBy: SortBy;
    sticky?: boolean;
    sortingTitle?: string;
    createAttributePopover?: boolean;
    createMeteringDirectionPopOver?: boolean;
    createHeightReferencePopOver?: boolean;
    qualityParam?: QualityParam,
    attributeType?: AttributeType;
}

interface StateProps {
    sortSetting?: SortSetting,
    focusedFeature?: DisplayFeature,
}

interface DispatchProps {
    doPreserveFocus?: PreserveFocus,
    doSortFeatures?: SortFeatures,
}

type SortingHeaderProps = TagProps & StateProps & DispatchProps;

const mapStateToProps = (state: FeaturesState): StateProps => {
    return {
        sortSetting: selectors.sortSetting(state),
        focusedFeature: selectors.focusedFeature(state),
    }
};

const mapDispatchToProps: DispatchProps = ({
    doSortFeatures: sortFeatures,
    doPreserveFocus: preserveFocus
});

class SortingHeader extends React.Component<SortingHeaderProps, SortingHeaderState> {

    constructor(props: SortingHeaderProps) {
        super(props);
        this.createMeteringDirectionPopOver = this.createMeteringDirectionPopOver.bind(this);
        this.createHeightReferencePopOver = this.createHeightReferencePopOver.bind(this);
    }

    render() {
        let isActiveSortingHeader = this.isActive();

        const headerClassNames = classNames({
            'sticky': this.props.sticky,
            'clickable': true,
            'active': isActiveSortingHeader
        });

        const iconClassNames = classNames(
            {
                'flex-shrink': true,
                'fa': true,
                'fa-sort': !isActiveSortingHeader
            },
            isActiveSortingHeader
                ? this.sortIconClass()
                : ''
        );
        return (
            <th className={headerClassNames} onClick={() => this.doSortOnMe()}>
                <div className={'flex'}>
                    <span className={'flex-grow'}>
                        {this.props.sortingTitle}
                        {this.props.createAttributePopover &&
                            this.createAttributePopover(this.props.attributeType)
                        }
                        {
                            this.props.createMeteringDirectionPopOver && this.createMeteringDirectionPopOver()
                        }
                        {
                            this.props.createHeightReferencePopOver && this.createHeightReferencePopOver()
                        }
                    </span>
                    <span className={iconClassNames}/>
                </div>
            </th>
        );
    }

    sortIconClass() {
        const isSortDesc = this.props.sortSetting && this.props.sortSetting.sortOrder === SortOrder.DESC;
        return isSortDesc ? 'fa-sort-down' : 'fa-sort-up';
    }

    isActive() {
        return (this.props.sortSetting &&
            this.props.sortBy === this.props.sortSetting.sortBy &&
            (
                (
                    this.props.sortSetting.sortBy === SortBy.ATTRIBUTE &&
                    this.props.sortSetting.attribute === this.props.attributeType
                ) ||
                (
                    this.props.sortSetting.sortBy === SortBy.QUALITY_PARAMETER &&
                    this.props.sortSetting.qualityParam === this.props.qualityParam
                ) ||
                (
                    this.props.sortSetting.sortBy !== SortBy.ATTRIBUTE &&
                    this.props.sortSetting.sortBy !== SortBy.QUALITY_PARAMETER
                )
            )
        );
    }

    doSortOnMe() {
        let focusedFeature = this.props.focusedFeature;
        if (!!focusedFeature) {
            this.props.doPreserveFocus(new PreserveFocusData(focusedFeature.id, false));
        }
        this.props.doSortFeatures(this.props.sortBy, this.props.attributeType, this.props.qualityParam);

    }

    createAttributePopover(attributeType: AttributeType) {

        const reqClass = "requirement-level " + attributeType.requirement;

        const popover = (
            <Popover id={'Attribute' + attributeType.id} title={attributeType.requirementDisplayName}>
                {attributeType.description}<br/>{attributeType.requirementComment}
            </Popover>
        );

        return (
            <OverlayTrigger trigger={['hover']} placement="top" overlay={popover}>
                <span>
                    <Glyphicon glyph="asterisk" className={reqClass}/>
                </span>
            </OverlayTrigger>
        );

    }

    createMeteringDirectionPopOver() {
        const popover = (
          <Popover id={this.props.sortingTitle + "-" + "-in-metering-direction"} title={"Metreringsretning"}>
              {this.props.sortingTitle} vises alltid i forhold til metreringsretning.
          </Popover>
        );

        return <OverlayTrigger overlay={popover} placement="top" trigger={["hover"]}>
            <span>
                <Glyphicon glyph={"asterisk"} className={`requirement-level LESS_IMPORTANT`}/>
            </span>
        </OverlayTrigger>
    }

    createHeightReferencePopOver() {
        const popover = (
          <Popover
            id={this.props.sortingTitle + "-" + "-height-reference"}
            title={"Høydereferanse"}
          >
            Høydereferanse angir om geometrien er innmålt ved bakkenivå (fot)
            eller i toppen (topp) av objektet. Nærmere beskrivelse finner du i
            excel-versjonen av objektliste.
          </Popover>
        );

        return <OverlayTrigger overlay={popover} placement="top" trigger={["hover"]}>
            <span>
                <Glyphicon glyph={"asterisk"} className={`requirement-level LESS_IMPORTANT`}/>
            </span>
        </OverlayTrigger>
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SortingHeader);
